/* Funnel events — names from the PRD §10 (rto_* contract). Sink: Firebase
   Analytics via GTM dataLayer (decision 2026-07-15); the backend mirrors the
   money milestones in rto_migration.state_history, so the experiment read
   never depends on this client alone. Fire-and-forget (FR-10.2). */

export type RtoEvent =
  | "rto_lp_login"
  | "rto_lp_ineligible_view"
  | "rto_offer_viewed"
  | "rto_plan_selected"
  | "rto_payment_link_generated"
  | "rto_migration_canceled"
  | "rto_collateral_paid"
  | "rto_contract_signed"
  | "rto_swap_scheduled"
  | "rto_migration_completed";

declare global {
  interface Window {
    dataLayer?: Record<string, unknown>[];
  }
}

export const track = (
  event: RtoEvent,
  payload: Record<string, unknown> = {},
): void => {
  try {
    window.dataLayer?.push({ event, lp: "conquista", ...payload });
    if (import.meta.env.DEV) console.log("[track]", event, payload);
  } catch {
    // analytics must never block the flow
  }
};
